import { render, staticRenderFns } from "./ClientGenerator.vue?vue&type=template&id=7b8483bb&scoped=true"
import script from "./ClientGenerator.vue?vue&type=script&lang=js"
export * from "./ClientGenerator.vue?vue&type=script&lang=js"
import style0 from "./ClientGenerator.vue?vue&type=style&index=0&id=7b8483bb&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b8483bb",
  null
  
)

export default component.exports